<template>
  <div :class="[pageClass, 'containerLayout']">
    <header>
      <img v-if="pageClass === 'puzzleWheelPage'" src="@/assets/logo.svg" alt="logo" class="logoPuzzleWheelPage">
      <img v-else src="@/assets/logo.svg" alt="logo" class="logoPage">
    </header>
    <main>
      <slot/>
    </main>
  </div>
</template>

<script>


export default {
  name: 'DefaultLayout',
  props: {
    pageClass: {
      type: String
    },
  },
};
</script>

<style>

@font-face {
  font-family: 'DrukFont';
  src: url('@/assets/fonts/Druk-font.otf') format('opentype');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'CorporateFont';
  src: url('@/assets/fonts/Corporate-font.otf') format('opentype');
  font-weight: normal;
  font-style: normal;
}

body, html {
  font-family: 'DrukFont', sans-serif;
  padding: 0;
  margin: 0;
}

.containerLayout {
  display: flex;
  flex-direction: column;
  position: relative;
  background-color: #101b52;
  width: 100%;
  height: 100%;
  min-height: 100vh;
  padding: 45px;

  @media only screen and (max-width: 1000px) {
    padding: 30px;
  }

  @media only screen and (max-width: 550px) {
    padding: 20px;
  }
}

.defaultPage {
  background-image: url('@/assets/backgroundImage.svg');
  background-size: cover;
  background-repeat: no-repeat;
}

.formPage {
  background-image: url('@/assets/backgroundImageHome.svg');
  background-size: cover;
  background-repeat: no-repeat;
}

.puzzleWheelPage {
  background-image: url('@/assets/backgroundImagePuzzleWheel.svg');
  background-size: cover;
  background-repeat: no-repeat;
}

header {
  display: flex;
  justify-content: center;
  place-items: center;
}

main {
  flex: 1; /* Allows main to take the remaining space between header and footer */
  position: relative; /* Necessary for positioning the arrow */
}

.logoPage {
  width: 30%;
  padding-top: 22px;
  padding-bottom: 81px;

  @media only screen and (max-width: 1000px) {
    width: 40%;
    padding-top: 20px;
    padding-bottom: 40px;
  }

  @media only screen and (max-width: 550px) {
    width: 45%;
    padding: 20px;
  }
}

.logoPuzzleWheelPage {
  width: 30%;
  padding-top: 22px;

  @media only screen and (max-width: 1000px) {
    width: 40%;
    padding-top: 20px;
  }

  @media only screen and (max-width: 550px) {
    width: 50%;
  }
}
</style>
